import { GetAllUsers } from '../actions/users';

export default (store) => {
    store.dispatch(GetAllUsers());
};
